<script>
import getSecret from '@utils/get-secret'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import BaseDatatable from '@components/base-datatable'
import { euroCouponsIssueMethods, euroCouponsTutorialMethods } from '@state/helpers'
import ThirdpartyMultiselect from '@components/euro_coupons/thirdparty/Select'
import CustomDatePickerRange from '@components/CustomDatePickerRange'
import CustomMultiselect from '@/src/components/CustomMultiselect.vue'

export default {
  name: 'EuroCouponsIssueIndex',
  page: {
    title: 'Novedades',
    meta: [{ name: 'description', content: getSecret('DESCRIPTION') }],
  },
  components: { 
    Layout, PageHeader, BaseDatatable,
    ThirdpartyMultiselect,
    CustomDatePickerRange,
    CustomMultiselect,
    EuroCouponsIssueDetail: () => import('@components/euro_coupons/issue/Detail'),
  },
  data() {
    return {
      title: this.$t('issues'),
      items: [
        {
          text: this.$t('home'),
          href: '/',
        },
        {
          text: this.$t('issues'),
          active: true,
        },
      ],

      reasonsOptions: [
        {label: 'Redención duplicada.', value: 1},
        {label: 'Factura genérica.', value: 2},
        {label: 'El valor no concuerda.', value: 3},
        {label: 'Documento Invalido.', value: 4},
        {label: 'Más de un bono disponible.', value: 5},
        {label: 'Bono sin factura asociada.', value: 6},
        {label: 'Bono no encontrado en Siesa.', value: 7},
      ],
      loadingReport: false,
      tableHeaders: [],
      toDetail : {},
      showDetail: false,
      filterset: null,
      filters: {
        thirdparty_id: null,
        reason: null,
        date__date__gte: null,
        date__date__lte: null,
      },
    }
  },

  mounted() {
    this.setShowTutorial(true)
    this.setTutorialUrl('novedades')
  },

  destroyed() {
    this.setShowTutorial(false)
  },

  beforeMount(){
    this.tableHeaders = [
        { key: 'thirdparty', label: this.$t('thirdparty') },
        // { key: 'cash_register', label: this.$t('cash_register') },
        // { key: 'cash_register_document', label: this.$t('cash_register_document') },
        // { key: 'CO', label: this.$t('CO') },
        { key: 'location', label: this.$t('location') },
        // { key: 'invoice', label: this.$t('invoice') },
        { key: 'date', label: this.$t('date') },
        // { key: 'invalid_document', label: this.$t('invalid_document') },
        // { key: 'beneficiary', label: this.$t('beneficiary') },
        { key: 'reason', label: this.$t('reason') },
        { key: 'actions', label: this.$t('actions') },
    ]
  },

  watch: {
    filters: {
      deep: true,
      handler(filters) {
        let filters_list = []
        for (let filter in filters) {
          if (filters[filter]) {
            filters_list.push(`${filter}=${filters[filter]}`)
          }
        }
        if (filters_list.length) {
          this.filterset = filters_list.join('&')
        }
        this.filter()
      },
    },
  },

  methods: {
    ...euroCouponsIssueMethods,
    ...euroCouponsTutorialMethods,
    myProvider(ctx) {
      let context = this
      ctx = context.$table_params(ctx)
      ctx += context.filterset ? `&${context.filterset}` : ''
      const promise = context.fetchEuroCouponsIssue({query: ctx})
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          console.log(error)
          return []
        })
    },
    setFilter(filter, value) {
      this.filters[filter] = value
    },

    filter() {
      this.$refs.table.lastFilter = ''
      this.$refs.table.onFiltered()
      setTimeout(() => this.$refs.table.refresh(), 200)
    },

    clear() {
      this.filters.thirdparty_id = null
      this.filters.reason = null
      this.filters.date__date__gte = null
      this.filters.date__date__lte = null
      
      this.filterset = null
      setTimeout(() => this.$refs.table.refresh(), 200)
    },

    getReport() {
      let _ = this
      _.loadingReport = true
      let query = '?download=true'
      query += _.filterset ? `&${_.filterset}`: ''
      const promise = _.fetchEuroCouponsIssue({
        query: query,
        type: { responseType: 'arraybuffer' },
      })
      return promise
        .then((response) => {
          const data = response.data
          const url = URL.createObjectURL(
            new Blob([data], {
              type: 'application/vnd.ms-excel',
            })
          )
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Reporte de novedades.xlsx`)
          document.body.appendChild(link)
          link.click()
          _.loadingReport = false
        })
        .catch((error) => {
          _.loadingReport = false
            console.error(error)
          _.$axios_error_noty('Se presento un error en la descarga del archivo.', )
        })
    },
    

  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container fluid class="p-0">
      <b-row>
        <b-col>
          <b-card class="shadow-sm">
            <b-row class="text-primary px-2 mb-2" style="font-size: 16px">
              <b>{{ $t('filters') }}</b>
            </b-row>
            <b-row>
              <b-col md="3">
                <ThirdpartyMultiselect
                  :value="filters.thirdparty_id"
                  @input="(value) => {
                    setFilter('thirdparty_id', value)
                    }"
                ></ThirdpartyMultiselect>
              </b-col>
              <b-col md="4">
                <CustomMultiselect
                  :label="'reason'"
                  :options="reasonsOptions"
                  :value="filters.reason"
                  @input="(value) => {
                    setFilter('reason', value)
                    }"
                ></CustomMultiselect>
              </b-col>
              <b-col md="4" class="p-0">
                <b-col
                  ><CustomDatePickerRange
                    :label="'date'"
                    :value_start="filters.date__date__gte"
                    :value_end="filters.date__date__lte"
                    @input_start="
                      (value) => setFilter('date__date__gte', value)
                    "
                    @input_end="
                      (value) => setFilter('date__date__lte', value)
                    "
                /></b-col>
              </b-col>
              <b-col md="1" class="ml-auto pt-3 pr-1 mt-1">
                <!-- <b-button
                  class="ml-1 rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="filter"
                  ><i class="fas fa-filter"></i>
                </b-button> -->
                <b-button
                  class="rounded shadow-sm float-right"
                  variant="outline-primary"
                  @click="clear"
                  ><i class="fas fa-eraser"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card class="shadow">


            <BaseDatatable
              ref="table"
              :drfprovider="myProvider"
              :tableheaders="tableHeaders"
            >
            <template v-slot:buttons>
                <b-button variant="outline-primary rounded-lg  mx-1"
                :disabled="loadingReport"
                  @click="getReport">

                  <b-spinner 
                  v-if="loadingReport"
                  small 
                  label="Spinning"></b-spinner>
                  <i v-else class="fas fa-download"></i>
                </b-button>

              </template>
              <template v-slot:cell(location)="row">
                <p class="p-0 m-0"><span class="font-weight-bold">DOC CAJERO:</span> {{row.item.cash_register_document}}</p>
                <p class="p-0 m-0"><i class="fas fa-map-marker-alt"></i> {{row.item.CO}} · {{row.item.cash_register}}</p>

              </template>
              <template v-slot:cell(reason)="row">
                {{row.item.reason.description}}
                <p v-if="row.value.type === 4"><i>Doc: {{row.item.invalid_document}}</i></p>
                <p  v-if="row.value.type === 1 || row.value.type === 5 || row.item.beneficiary" 
                  class="m-0">
                  <i>{{row.item.beneficiary.name}} - {{row.item.beneficiary.document_type}} {{row.item.beneficiary.document}}</i>
                </p>
              </template>
              <template v-slot:cell(actions)="row">
                <b-button-group size="xs">
                  <b-button
                    :id="`info-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'info',
                      placement: 'leftbottom',
                      title: $t('detail'),
                    }"
                    variant="btn-link text-info btn-transparent"
                    size="xs"
                    @click="()=>{showDetail=true; toDetail=row.item}"
                  >
                    <i
                      class="fe-info fe-2x"
                    ></i>
                  </b-button>

                  <!-- <b-button
                    :id="`update-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'warning',
                      placement: 'leftbottom',
                      title: $t('edit'),
                    }"
                    variant="btn-link text-warning btn-transparent"
                    size="xs"
                    @click="()=>{showForm=true; toUpdate=row.item}"
                  >
                    <i class="fe-edit fe-2x"></i>
                  </b-button>

                  <b-button
                    :id="`delete-btn-${row.index}`"
                    v-b-tooltip.hover="{
                      variant: 'danger',
                      placement: 'leftbottom',
                      title: $t('delete'),
                    }"
                    variant="btn-link text-danger btn-transparent"
                    size="xs"
                    @click="()=>{showDelete=true; toDelete=row.item}"
                  >
                    <i class="fe-x fe-2x"></i>
                  </b-button> -->
                </b-button-group>
              </template>
            </BaseDatatable>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <!-- Detail modal -->
    <EuroCouponsIssueDetail
      v-if="showDetail"
      :instanceJson="toDetail || {}"
      :oncomplete="
        () => {
          showDetail = false;
          toDetail = {};
        }
      "
      :oncancel="
        () => {
          showDetail = false;
          toDetail = {}
        }
      "
    >
    </EuroCouponsIssueDetail>

  </Layout>
</template>
